import { render, staticRenderFns } from "./QuotNotification.vue?vue&type=template&id=7adc5476&scoped=true"
import script from "./QuotNotification.vue?vue&type=script&lang=js"
export * from "./QuotNotification.vue?vue&type=script&lang=js"
import style0 from "./QuotNotification.vue?vue&type=style&index=0&id=7adc5476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adc5476",
  null
  
)

export default component.exports